import React from 'react';
import { motion } from 'framer-motion';
import { CreditCard, MessageCircle, Video, Flame, ArrowRight } from 'lucide-react';
const steps = [{
  icon: CreditCard,
  title: 'Reservás tu lugar',
  desc: 'Pagás una vez, acceso inmediato.'
}, {
  icon: MessageCircle,
  title: 'Entrás al grupo',
  desc: 'El link de WhatsApp llega a tu Gmail al instante.'
}, {
  icon: Video,
  title: 'Arrancamos en vivo',
  desc: 'Cuando se completan los 20 cupos, empieza la mentoría por Zoom.'
}, {
  icon: Flame,
  title: 'Construís disciplina',
  desc: 'Aplicás lo que aprendés. Tu vida cambia.'
}];
export function HowItWorksSection() {
  return <section className="py-24 bg-[#0a0a0a] relative overflow-hidden" data-id="element-98">
      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-99">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-100">
          <span className="text-[#C9A84C] tracking-[0.2em] text-xs font-bold uppercase mb-3 block" data-id="element-101">
            El proceso
          </span>
          <h2 className="text-4xl md:text-5xl font-['Bebas_Neue'] text-white" data-id="element-102">
            CÓMO FUNCIONA
          </h2>
          <div className="w-12 h-[1px] bg-[#C9A84C] mx-auto mt-4" data-id="element-103" />
        </motion.div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 relative" data-id="element-104">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-8 left-[12%] right-[12%] h-[2px] bg-gradient-to-r from-[#C9A84C]/20 via-[#C9A84C]/40 to-[#C9A84C]/20 -z-10" data-id="element-105" />

          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.15
        }} className="flex flex-col items-center text-center group" data-id="element-106">
              {/* Icon Circle */}
              <div className="relative mb-6" data-id="element-107">
                <div className="w-16 h-16 rounded-full bg-[#111] border border-[#C9A84C]/30 flex items-center justify-center group-hover:border-[#C9A84C] transition-colors duration-300 shadow-[0_0_20px_rgba(201,168,76,0.1)]" data-id="element-108">
                  <step.icon className="w-7 h-7 text-[#C9A84C]" data-id="element-109" />
                </div>
                {/* Number Badge */}
                <div className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-[#C9A84C] text-black text-xs font-bold flex items-center justify-center border-2 border-[#0a0a0a]" data-id="element-110">
                  {i + 1}
                </div>
              </div>

              {/* Content */}
              <h3 className="text-xl font-['Bebas_Neue'] text-white mb-3 tracking-wide" data-id="element-111">
                {step.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed max-w-[200px]" data-id="element-112">
                {step.desc}
              </p>

              {/* Mobile Arrow (except last) */}
              {i < steps.length - 1 && <div className="md:hidden mt-8 mb-4 text-[#C9A84C]/30" data-id="element-113">
                  <ArrowRight className="w-6 h-6 rotate-90" data-id="element-114" />
                </div>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}